import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { style: {"display":"flex","flex-direction":"row"} }
const _hoisted_2 = { class: "answer" }
const _hoisted_3 = { class: "answer" }
const _hoisted_4 = {
  key: 0,
  class: "calculation"
}

import {
  Co2QuizAnswer,
  Co2QuizQuestion,
  calculationLabelItems,
} from '@/models/co2-quiz.model';
import { UserLabel } from '@/models/label.model';
import { PropType, ref, watch } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'Co2QuizAnswersField',
  props: {
  modelValue: {
    type: Object as PropType<Co2QuizAnswer[]>,
    required: true,
  },
  questions: {
    type: Array as PropType<Co2QuizQuestion[]>,
    required: true,
  },
  labels: {
    type: Array as PropType<UserLabel[]>,
    required: true,
  },
},
  emits: ['update:modelValue', 'change'],
  setup(__props, { emit: __emit }) {

const props = __props;

const answers = ref<Co2QuizAnswer[]>([
  ...(props.modelValue || []).sort((a, b) => a.index - b.index),
]);

const showDetails = ref<{ [index: number]: boolean }>({});

const emit = __emit;

function update() {
  emit('update:modelValue', answers.value);
  emit('change');
}

function addAnswer() {
  answers.value.push({
    text: '',
    unitAmount: 0,
    index: answers.value.length,
    isAverage: false,
    isOther: false,
    calculationLabels: [],
    providesLabels: [],
  });
  update();
}

function removeAnswer(index: number) {
  answers.value.splice(index, 1);
  update();
}

function moveUp(answer: Co2QuizAnswer) {
  const index = answers.value.findIndex((a) => a.id === answer.id);

  answers.value = [
    ...answers.value.slice(0, index - 1),
    answer,
    answers.value[index - 1],
    ...answers.value.slice(index + 1),
  ].map((v, index) => ({ ...v, index }));

  update();
}

function moveDown(answer: Co2QuizAnswer) {
  const index = answers.value.findIndex((a) => a.id === answer.id);

  answers.value = [
    ...answers.value.slice(0, index),
    answers.value[index + 1],
    answer,
    ...answers.value.slice(index + 2),
  ].map((v, index) => ({ ...v, index }));

  update();
}

watch(
  () => props.modelValue,
  () => {
    Object.assign(answers.value, props.modelValue);
  },
  { deep: true },
);

return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[0] || (_cache[0] = _createElementVNode("h3", null, "Answers", -1)),
        _renderSlot(_ctx.$slots, "default")
      ]),
      _createVNode(_component_v_list, null, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(answers.value, (answer, index) => {
            return (_openBlock(), _createBlock(_component_v_list_item, { key: index }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card, null, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_2, [
                      _createVNode(_component_v_text_field, {
                        modelValue: answer.text,
                        "onUpdate:modelValue": ($event: any) => ((answer.text) = $event),
                        label: "Answer",
                        width: "45%",
                        placeholder: `Answer ${index + 1}`,
                        required: "",
                        density: "compact",
                        hideDetails: "",
                        onChange: update
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"]),
                      _cache[1] || (_cache[1] = _createTextVNode("   ")),
                      _createVNode(_component_v_text_field, {
                        modelValue: answer.unitAmount,
                        "onUpdate:modelValue": ($event: any) => ((answer.unitAmount) = $event),
                        modelModifiers: { number: true },
                        width: "25%",
                        label: "Amount",
                        "append-icon": 
                showDetails.value[index]
                  ? 'mdi-menu-up-outline'
                  : 'mdi-menu-down-outline'
              ,
                        "onClick:append": ($event: any) => (showDetails.value[index] = !showDetails.value[index]),
                        required: "",
                        density: "compact",
                        hideDetails: "",
                        onChange: update
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "append-icon", "onClick:append"]),
                      _createVNode(_component_v_btn, {
                        icon: "mdi-arrow-up",
                        class: "remove-button",
                        density: "compact",
                        disabled: index === 0 || answer.id === undefined,
                        onClick: _withModifiers(($event: any) => (moveUp(answer)), ["prevent"])
                      }, null, 8, ["disabled", "onClick"]),
                      _cache[2] || (_cache[2] = _createTextVNode("   ")),
                      _createVNode(_component_v_btn, {
                        icon: "mdi-arrow-down",
                        class: "remove-button",
                        density: "compact",
                        disabled: 
                index === answers.value.length - 1 || answer.id === undefined
              ,
                        onClick: _withModifiers(($event: any) => (moveDown(answer)), ["prevent"])
                      }, null, 8, ["disabled", "onClick"]),
                      _cache[3] || (_cache[3] = _createTextVNode("   ")),
                      _createVNode(_component_v_btn, {
                        icon: "mdi-delete-outline",
                        class: "remove-button",
                        density: "compact",
                        onClick: _withModifiers(($event: any) => (removeAnswer(index)), ["prevent"])
                      }, null, 8, ["onClick"])
                    ]),
                    _createElementVNode("div", _hoisted_3, [
                      _createVNode(_component_v_checkbox, {
                        modelValue: answer.isAverage,
                        "onUpdate:modelValue": ($event: any) => ((answer.isAverage) = $event),
                        label: "Average",
                        density: "compact",
                        class: "mr-16"
                      }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                      _createVNode(_component_v_checkbox, {
                        modelValue: answer.isOther,
                        "onUpdate:modelValue": ($event: any) => ((answer.isOther) = $event),
                        label: "Other",
                        density: "compact"
                      }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                      (answer.followUpQuestion)
                        ? (_openBlock(), _createBlock(_component_v_chip, {
                            key: 0,
                            density: "compact",
                            class: "mt-2 ml-4",
                            color: "info"
                          }, {
                            default: _withCtx(() => _cache[4] || (_cache[4] = [
                              _createTextVNode("Has Follow up")
                            ])),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (answer.providesLabels.length)
                        ? (_openBlock(), _createBlock(_component_v_chip, {
                            key: 1,
                            density: "compact",
                            class: "mt-2 ml-4",
                            color: "green"
                          }, {
                            default: _withCtx(() => _cache[5] || (_cache[5] = [
                              _createTextVNode("Provides labels")
                            ])),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (answer.resetsQuestions?.length)
                        ? (_openBlock(), _createBlock(_component_v_chip, {
                            key: 2,
                            density: "compact",
                            class: "mt-2 ml-4",
                            color: "warning"
                          }, {
                            default: _withCtx(() => _cache[6] || (_cache[6] = [
                              _createTextVNode("Resets questions")
                            ])),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    (showDetails.value[index])
                      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                          _cache[7] || (_cache[7] = _createElementVNode("h4", null, "Details", -1)),
                          _createVNode(_component_v_select, {
                            modelValue: answer.calculationLabels,
                            "onUpdate:modelValue": ($event: any) => ((answer.calculationLabels) = $event),
                            label: "Calculation Labels",
                            class: "calculation-field",
                            chips: "",
                            "hide-details": "auto",
                            style: { background: 'white' },
                            multiple: "",
                            items: _unref(calculationLabelItems)
                          }, {
                            item: _withCtx(({ props }) => [
                              _createVNode(_component_v_list_item, _mergeProps({ ref_for: true }, props), {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list_item_title)
                                ]),
                                _: 2
                              }, 1040)
                            ]),
                            _: 2
                          }, 1032, ["modelValue", "onUpdate:modelValue", "items"]),
                          _createVNode(_component_v_select, {
                            modelValue: answer.followUpQuestion,
                            "onUpdate:modelValue": ($event: any) => ((answer.followUpQuestion) = $event),
                            label: "Follow up question",
                            class: "calculation-field",
                            "hide-details": "auto",
                            style: { background: 'white' },
                            items: __props.questions.map((q) => ({ title: q.title, value: q }))
                          }, {
                            item: _withCtx(({ props }) => [
                              _createVNode(_component_v_list_item, _mergeProps({ ref_for: true }, props), {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list_item_title)
                                ]),
                                _: 2
                              }, 1040)
                            ]),
                            _: 2
                          }, 1032, ["modelValue", "onUpdate:modelValue", "items"]),
                          _createVNode(_component_v_select, {
                            modelValue: answer.resetsQuestions,
                            "onUpdate:modelValue": ($event: any) => ((answer.resetsQuestions) = $event),
                            label: "Resets questions",
                            multiple: "",
                            "hide-details": "auto",
                            style: { background: 'white' },
                            items: __props.questions.map((q) => ({ title: q.title, value: q }))
                          }, {
                            item: _withCtx(({ props }) => [
                              _createVNode(_component_v_list_item, _mergeProps({ ref_for: true }, props), {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list_item_title)
                                ]),
                                _: 2
                              }, 1040)
                            ]),
                            _: 2
                          }, 1032, ["modelValue", "onUpdate:modelValue", "items"]),
                          _createVNode(_component_v_select, {
                            modelValue: answer.providesLabels,
                            "onUpdate:modelValue": ($event: any) => ((answer.providesLabels) = $event),
                            label: "Provides labels",
                            multiple: "",
                            clearable: "",
                            class: "mt-4",
                            "hide-details": "auto",
                            style: { background: 'white' },
                            items: __props.labels.map((q) => ({ title: q.value, value: q }))
                          }, {
                            item: _withCtx(({ props }) => [
                              _createVNode(_component_v_list_item, _mergeProps({ ref_for: true }, props), {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list_item_title)
                                ]),
                                _: 2
                              }, 1040)
                            ]),
                            _: 2
                          }, 1032, ["modelValue", "onUpdate:modelValue", "items"])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      }),
      _createVNode(_component_v_btn, {
        onClick: addAnswer,
        color: "success"
      }, {
        default: _withCtx(() => _cache[8] || (_cache[8] = [
          _createTextVNode("Add answer")
        ])),
        _: 1
      })
    ]),
    _: 3
  }))
}
}

})